import { httpPost } from 'utils';
import { InvestOffer } from '../types';

interface InvestNowResponse {
  isSuccess: boolean;
}

export const investNowApi = (config?: InvestOffer) =>
  httpPost<InvestNowResponse, InvestOffer>('portal/InvestNow', config);
